import Animate, { AnimationTypes } from "../../components/Animate/Animate"
import { ICartSummary } from "../Helpers/CalculateCartSummary"

interface AwardListProps {
  summary: ICartSummary
}

export const AwardAppliedList: React.FC<AwardListProps> = ({ summary }) => {
  if (!summary.awards.length) return null

  return (
    <Animate type={AnimationTypes.slideUpIn} duration="1.5s">
      <div className="space-y-1">
        {summary.awards.map(({ awardManager, discount }) => (
          <div
            key={awardManager.id}
            className="bg-yellow-50/75 border-2 border-yellow-500 p-3 rounded-lg flex items-center justify-between"
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-yellow-500 rounded-lg flex items-center justify-center">🎁</div>

              <div>
                <p className="text-xs font-black text-yellow-800 uppercase">{awardManager.awardEntity?.name}</p>

                <p className="text-[10px] text-yellow-700">{awardManager.awardEntity?.getValueToString()}</p>
              </div>
            </div>

            <span className="text-sm font-black text-green-600">- R$ {discount.toFixed(2)}</span>
          </div>
        ))}
      </div>
    </Animate>
  )
}
